var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton-theme',{staticClass:"skeleton-loader-group",attrs:{"color":_vm.skeletonColor,"highlight":_vm.skeletonHighlight}},[_vm._t("default"),_vm._v(" "),_vm._t("skeleton",null,{"customStyle":_vm.customStyle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }